import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useToast } from "./use-toast";

import { auth } from "../../firebase";
import firestoreService from "../../services/firestoreService";

const useProject = (projectId) => {
  const [project, setProject] = useState(() => {
    if (!projectId) {
      return {
        name: "",
        description: "",
        context: "",
        riskMatrix: "",
        roles: {
          owners: [auth.currentUser.uid],
          editors: [],
          viewers: [],
        },
        acronym: "",
        hazardCounter: 1,
        mitigationCounter: 1,
        hazardStatusCount: {
          open: 0,
          managed: 0,
          resolved: 0,
          forTransfer: 0,
          transferred: 0,
          closed: 0,
          cancelled: 0,
        },
      };
    }
  });

  const { toast } = useToast();
  const navigate = useNavigate();

  const fetchProject = useCallback(
    (projectId) => {
      const unsubscribe = firestoreService.subscribeToItem(
        "projects",
        projectId,
        [],
        (project) => {
          if (!project) {
            console.error(
              "Project missing: Unable to retrieve specified project."
            );

            toast({
              variant: "destructive",
              title: "Project missing",
              description: "Unable to retrieve specified project.",
            });

            navigate("/projects");
            return;
          }

          setProject(project);
        }
      );

      return () => unsubscribe();
    },
    [navigate, toast]
  );

  useEffect(() => {
    if (projectId) {
      fetchProject(projectId);
    }
  }, [fetchProject, projectId]);

  return { project, setProject };
};

export default useProject;
